import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FeaturesListComponent } from '@ibe.components/shared/flight-brand-features-list/features-list.component';
import { Flight } from '@ibe/models';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_LOUNGE, EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_MEAL, EXTRAS_ANCILLARY_SEAT, UNCONFIRMED_CODES, SESSION_VAR_KEY_CURRENCY, EXTRAS_ANCILLARY_PREF_BOARD, SSR_CODE_MEAL_SKIP } from '@ibe.config';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { Observable, Subscription } from 'rxjs';
import { ImpressionFieldObject } from '@ibe.models/google-analytics.indra.model';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_CLICK } from '@ibe.services/google.analytics.indra.service';
import { ModalService } from '@ibe/services/ui';
import { INDRAPackModalComponent } from '../bundles-modal/pack-modal.indra.component';
import { Bundles } from '@ibe.components/booking/extras/bundles/bundles';
import { PACK2, PACK3, PACK4, brandExtraFeature, packFeature } from '@ibe.components/booking/flights/brand/brand';

import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAPackService } from '../sidebar-views/ancillaries/pack/pack.service.indra';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-features-list',
	templateUrl: './features-list.indra.component.html',
	styleUrls: ['./features-list.component.scss'],
	host: {
		class: 'app-features-list'
	}
})
export class INDRAFeaturesListComponent extends FeaturesListComponent
	implements OnInit, OnDestroy {

	private _features;
	payWithMiles: boolean = false;

	@Input()
	set features(data) {
		this._features = Object.assign([], data);
	}

	@Input()
	title: string;

	@Input()
	titleKey: string;

	@Input()
	state: 'expanded' | 'collapsed' = 'collapsed';

	@Input()
	flight?: any;
	
	@Input()
	flightId?: any;

	@Input()
	hasUnaccompaniedMinor?: boolean = false;

	@Input()
	allAreUnaccompaniedMinor?: boolean = false;

	@Output()
	addFeature = new EventEmitter();

	@Output()
	detailsFeature = new EventEmitter();

	@Output()
	passengerIncluded = new EventEmitter();

	@Input()
	flight_packs: any = [];

	primaryFeaturesCount = 0;
	secondaryFeaturesCount = 0;
	totalFeaturesCount = 0;
	see_more_secondary: 'see-less' | 'see-more' = 'see-less';

	featuresAdded: INDRAAddOnAncillary[];

	activeBookedTrip = null;
	ancillariesPrices = null;
	itemsCurrencyCode: string;

	filteredPrimaryFeatures = [];
	featuresLoaded = false;

	allSubscriptions: Subscription[] = [];
	shoppingCartSubscription: Subscription;
	packSubscription: Subscription;
	prevCurrentPacks: any[] = [];

	seeMoreDisplayed: boolean = false;

	ancillariesAddedToPayWithMiles$: Observable<Array<any>> = this.store.select(fromStore.getAncillariesAddedToPayWithMiles);
	ancillariesAddedToPayWithMiles: any[];

	bundle: Bundles;

	// Corp
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;
	// promotype: string;

	constructor(
		private store: Store<fromStore.State>,
		private bfmStorage: INDRABFMDataStorageService,
		private ancillariesShoppingCart: INDRAAncillariesShoppingCartService,
		private bookingService: INDRABookingService,
		private gaService: INDRAGoogleAnalyticsService,
		private packService: INDRAPackService,
		private modalService: ModalService,
		private ibeAdminService: INDRAIbeAdminService,
	) {
		super();
	}

	ngOnInit() {
		this.INDRA_loadFeatures();
		this.activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.shoppingCartSubscription = this.ancillariesShoppingCart.INDRA_getAncillariesShoppingCart(this.activeBookedTrip.data.pnr).subscribe(
			result => {
				if (this.flight) {
					this.featuresAdded = result.itemsAdded.filter((item) => {
						return item.enabled === true && (
							item.flightCardId === this.flight.details.assignedFlightId.toString()
						)
					});

					const packs = this.bfmStorage.INDRA_getAncillariesPacks();
					this.bundle = new Bundles(this.flight, packs, this._features, this.featuresAdded);
				}
			}
		);
		this.INDRA_getExtrasPrices();

		if (this.activeBookedTrip['ancillaries-data']) {
			this.itemsCurrencyCode = this.activeBookedTrip['ancillaries-data']['bundleList'].filter(bundle => bundle.ancillaryList.length && bundle.ancillaryList[0].catalog)[0].ancillaryList[0].catalog[0].passengers[0].codeList[0].currency;
		}
		if (this.flight_packs.length > 0) {
			this.packSubscription = this.packService.currentPacks.subscribe(value => {
				if (value.length) {
					//A pack has been deselected
					if (this.prevCurrentPacks.length > value.length) {
						this.prevCurrentPacks.filter(pack => !value.some(pck => pck.flightId == pack.flightId && pck.type == pack.type)).forEach(pck => {
							pck.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(feature => {
								const element = document.getElementById(`${feature.type}_${pck.flightId}`);
								if (element) {
									element.style.display = '';
								}
							});
						});
						this.prevCurrentPacks = value;
					//A pack has been selected
					} else {
						// Checks if a ancillary included in the pack could be purchased for other segment, and hides ancillaries that can't be purchased
						this.INDRA_ancillariesWhitelist(value, this.flightId, this.activeBookedTrip["ancillaries-data"].bundleList);
						this.prevCurrentPacks = value;
					}
				} else {
					//A pack has been deselected
					if (this.prevCurrentPacks.length > value.length) {
						this.prevCurrentPacks.filter(pack => !value.some(pck => pck.flightId == pack.flightId && pck.type == pack.type)).forEach(pck => {
							pck.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(feature => {
								const element = document.getElementById(`${feature.type}_${pck.flightId}`);
								if (element) {
									element.style.display = '';
								}
							});
						});
						this.prevCurrentPacks = value;
					}
				}
			});
		}

		this.allSubscriptions.push(this.packSubscription);
		this.allSubscriptions.push(this.shoppingCartSubscription);
	}

	INDRA_showPromoText(): boolean {
		const translation = this.ibeAdminService.getTranslationValue('bookingDetails.text.sale');
		if ('bookingDetails.text.sale' === translation || translation === "") {
			// No translation value on IBEAdmin
			return false;
		} else {
			return true;
		}
	}

	/**
	 * Toggle the expanded/collapsed state;
	 */
	handleToggle() {
		if (this.state === 'expanded') {
			this.state = 'collapsed';
		} else {
			this.state = 'expanded';
		}
	}

	/**
	 * Toggle the expanded/collapsed state;
	 */
	openToggle() {
		if (this.state === 'collapsed') {
			this.state = 'expanded';
		}
	}

	/**
	 * Toggle the expanded/collapsed state;
	 */
	handleExtrasSeeMoreToggle() {
		if (this.see_more_secondary === 'see-less') {
			this.see_more_secondary = 'see-more';
		} else {
			this.see_more_secondary = 'see-less';
		}
	}

	// /**
	//  * Each feature must have a different collapsed state to appear side by side
	//  * @param index - index of the feature in the list,
	//  * @returns an NgStyle object for the indexed feature
	//  */
	// INDRA_featureStyles(index: number): Object {
	// 	const iconWidth = 32;
	// 	if (this.state === 'collapsed') {
	// 		return { 'margin-left': iconWidth * index + 'px' };
	// 	} else {
	// 		return {};
	// 	}
	// }

	/**
	 * Returns classes for each feature
	 * @param feature - feature in the list,
	 * @returns an NgClass object for the indexed feature
	 */
	INDRA_featureClasses(feature): Object {
		const result = {
			'expanded': this.state === 'expanded',
			'collapsed': this.state === 'collapsed',
			'extras-feature--secondary': feature.secondary,
			'no-icon': !this.INDRA_hasIcon(feature)
		};

		if (feature.cssClass) {
			result[feature.cssClass] = true;
		}

		// to prevent multiple/continuous verbose warnings on console
		return Object.entries(result).filter(cur => cur[1]).map(cur => cur[0]).join(' ');

	}

	/**
	 * Returns list of features
	 * @returns list of features
	 */
	INDRA_getFeatures() {
		this.totalFeaturesCount = this._features.length;
		return this._features;
	}

	INDRA_hasAnyBagPackSelected(){
		if (!this.bundle) {
			return false;
		}

		return this.bundle.INDRA_hasAnyBagPackSelected();
	}

	INDRA_getBagsbyPack(){
		if (!this.bundle) {
			return 0;
		}

		return this.bundle.INDRA_getBagsbyPack();
	}

	/**
	 * Returns if feature has an icon to show
	 * @param feature
	 */
	INDRA_hasIcon(feature) {
		return feature.icon != null;
	}

	/**
	 * Emits the @action of the feature to the parent
	 * @param action
	 */
	INDRA_handleOpenExtra(feature) {
		const action = feature.action;
		let extraInPack = this.bundle.extras_availables.find(e => e.id == feature.id);

		if (
			extraInPack &&
			this.bundle &&
			this.bundle.INDRA_getPacksbyExtra(feature).length > 0
			&& this.featureCount(feature) === 0
		) {
			this.modalService.assignComponent(INDRAPackModalComponent, { bundle: this.bundle, flight: this.flight, selectedExtra: feature.id });
			this.modalService.open();
		} else {
			this.INDRA_registerGAClickExtra(action);
			this.addFeature.emit(action);
		}
	}

	INDRA_registerGAClickExtra(action: { route: string }) {
		const ancillary = this._features.find(feature => feature.action.route === action.route);
		const product = { code: ancillary.type } as INDRAAddOnAncillary;
		const eventDataLayerObject = this.gaService.IBE_createGA_AncillaryProducts(product, ancillary.name);
		eventDataLayerObject.actionField = this.gaService.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);
		this.gaService.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));

	}

	/**
	 * Emits the @details of the feature to the parent
	 * @param details
	 */
	INDRA_handleOpenExtraDetails(details: { route: string }) {
		this.detailsFeature.emit(details);
	}


	/**
	 * Emits the call to open passenger-included sidebar to the parent
	 */
	INDRA_handleOpenPassengerIncluded() {
		this.passengerIncluded.emit();
	}

	hasChanged(feature) {
		const featureChanged = new FeaturesMap(this.flight, this.featuresAdded).hasChanged(feature);
		if (featureChanged && feature.secondary && this.see_more_secondary === 'see-less' && !this.seeMoreDisplayed) {
			this.handleExtrasSeeMoreToggle();
			this.seeMoreDisplayed = true;
		}
		return featureChanged;
	}

	featureCost(feature) {
		/* // note: from Sprint 8 merge // TODO check if this needs to be implemented
		const extra = this.ancillariesAddedToPayWithMiles.find(item => {
			const featureLabel = feature.label.toLowerCase();
			const itemTofind = item.name.toLowerCase();
			if (featureLabel.indexOf(itemTofind) > -1) {
				this.payWithMiles = false;
				return item;
			}
		});
		if (extra) {
			this.payWithMiles = true;
			return this.TAP_formatMiles(extra.total);
		}
		return this.TAP_formatCash(new FeaturesMap(this.flight).getCost(feature));
		*/
		return new FeaturesMap(this.flight, this.featuresAdded).getCost(feature);
	}

	featureCount(feature) {
		return new FeaturesMap(this.flight, this.featuresAdded).getCount(feature);
	}

	INDRA_getNoMeal() {
		return new FeaturesMap(this.flight, this.featuresAdded).executeMethod('meals', 'skip_count') == null ? 0 : new FeaturesMap(this.flight, this.featuresAdded).executeMethod('meals', 'skip_count') as number;
	}

	itemCurrencyCode(feature) {
		if (feature.type == 'SEAT') {
			return (feature.currency ? feature.currency : this.itemsCurrencyCode);
		} else {
			return this.itemsCurrencyCode;
		}
	}

	INDRA_getSegmentIDs(): string[] {
		return this.flight.details.listSegment.map(segment => segment.idInfoSegment + '');
	}

	INDRA_getExtrasPrices() {
		const ancillariesCodes = {};
		if (this.flight && this.flight.details) {
			let priceFilter = {
				idFlight: this.flight.details.idFlight,
				listSegmentId: this.INDRA_getSegmentIDs()
			};

			if (this.activeBookedTrip && this.activeBookedTrip['ancillaries-data']['bundleList']) {
				const bundleList = this.activeBookedTrip['ancillaries-data']['bundleList'];
				bundleList.forEach(bundleItem => {
					bundleItem.ancillaryList.forEach(ancillaryItem => {
						if (ancillaryItem && ancillaryItem.catalog && ancillaryItem.catalog.length > 0) {
							ancillaryItem.catalog.forEach(catalogItem => {
								const parsedFlightId = parseInt(catalogItem.flightId);
								if (catalogItem.segmentId && parsedFlightId === priceFilter.idFlight
									&& priceFilter.listSegmentId.includes(catalogItem.segmentId.toString())) {
									if (catalogItem.passengers.length > 0) {
										const isHighlight = catalogItem.passengers[0].codeList.some(item => item.isHighlight) != undefined ? catalogItem.passengers[0].codeList.some(item => item.isHighlight) : false;
										const prevItemPrices = catalogItem.passengers[0].codeList.map(item => Number(item.mnbPrice));
										const hasMnbPrice = prevItemPrices.filter(price => !isNaN(price)).length > 0;
										const itemPrices = catalogItem.passengers[0].codeList.map(item => Number(item.price));
										const sum = itemPrices.reduce((total, amount) => {
											return total + amount;
										}, 0.00);
										if (this.hasUnaccompaniedMinor && !this.allAreUnaccompaniedMinor
											&& ancillaryItem.type === EXTRAS_ANCILLARY_SEAT) {
											ancillariesCodes[ancillaryItem.type] = {price: '0.00', previous_price: '', hasMnbPrice: hasMnbPrice, isHighlight: isHighlight};
										} else {
											let tempAncillaryPricetext;
											let tempAncillaryPrevPricetext;
											if (hasMnbPrice) {
												const minPriceIndex = this.INDRA_getMinPriceIndex(itemPrices, prevItemPrices);
												tempAncillaryPricetext = (sum == Number(0.00) ? 'for free' : itemPrices[minPriceIndex].toString());
												tempAncillaryPrevPricetext = prevItemPrices[minPriceIndex].toString();
											} else {
												tempAncillaryPricetext = (sum == Number(0.00) ? 'for free' : Math.min(...itemPrices).toString());
												tempAncillaryPrevPricetext = "";
											}
											if (ancillariesCodes[ancillaryItem.type]) {
												if (ancillariesCodes[ancillaryItem.type].price === 'for free') {
													if (tempAncillaryPricetext !== 'for free') {
														ancillariesCodes[ancillaryItem.type] = {price: tempAncillaryPricetext, previous_price: tempAncillaryPrevPricetext, hasMnbPrice: hasMnbPrice, isHighlight: isHighlight};
													}
												}
												// If highlight available for either segment of bound, set to true
												// Highlight should be shown when at least 1 segment contains it
												if (!ancillariesCodes[ancillaryItem.type].isHighlight && isHighlight) {
													ancillariesCodes[ancillaryItem.type].isHighlight = isHighlight;
												}
											} else {
												ancillariesCodes[ancillaryItem.type] = {price: tempAncillaryPricetext, previous_price: tempAncillaryPrevPricetext, hasMnbPrice: hasMnbPrice, isHighlight: isHighlight};
											}
										}
									}
								}
							});
						}
					});
				});
			}
		}
		this.ancillariesPrices = ancillariesCodes;
		this.featuresLoaded = true;
	}

	INDRA_isHighlight(feature) {
		if (this.ancillariesPrices[feature.type] && this.ancillariesPrices[feature.type].isHighlight) {
			return 'highlight';
		} else {
			return '';
		}
	}

	INDRA_getMinPriceIndex(itemPrices, prevItemPrices) {
		let availableIndexes = [];
		let lowestPrice: number;
		let lowestPriceIndex: number;	
		prevItemPrices.forEach((value, index) => {
			if (!isNaN(value)) {
				availableIndexes.push(index);
			}
		});	
		availableIndexes.forEach((value, index) => {
			if ((itemPrices[value] < lowestPrice || index === 0)) {
				lowestPrice = itemPrices[value];
				lowestPriceIndex = value;
			}
		});
		return lowestPriceIndex;
	}

	INDRA_checkIsNaN(value) {
		return isNaN(value);
	}

	INDRA_getStatusKey(statusCode: number) {
		this.ancillariesShoppingCart.INDRA_getStatusKey(statusCode);
	}

	INDRA_checkIfUnconfirmed(feature) {
		if (!feature.unconfirmed || feature.unconfirmed.length < 1) {
			return false;
		}
		return true;
	}

	INDRA_loadFeatures() {
		this.filteredPrimaryFeatures = this.INDRA_getFeatures();

		// At this moment we're just sending impressions from catalog when add more sidebars are open
		// this.INDRA_sendGAImpressions();
	}

	ngOnDestroy() {
		for (const sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

	INDRA_sendGAImpressions() {
		let brand = null;
		if (this.flight && this.flight.details && this.flight.details.fareFamily) {
			brand = this.bookingService.INDRA_getBrandCode(this.flight.details.fareFamily);
		}

		if (this.filteredPrimaryFeatures.length > 0) {
			this.filteredPrimaryFeatures.forEach((item, index) => {
				const product: ImpressionFieldObject = {
					id: item.type,
					name: item.name,
					list: (item.action ? item.type : 'What\'s included list'),
					brand: brand,
					category: 'Ancillaries',
					position: index + 1,
				};
				// if (item.action)
				// this.googleAnalytics.INDRA_addImpression(product);
			});
			// this.googleAnalytics.INDRA_sendEvent(EVENT_CATEGORY_ANCILLARIES, EVENT_LABEL_EC, EVENT_ACTION_IMPRESSION);
		} else {
		}

	}
	INDRA_ancillariesWhitelist(selectedPacks, flightId, bundleList) {
		let ancillariesOnOtherSegment = [];
		let selectedPackAncillaries = [];

		// Gather all ancillaries added on packs for all segments
		selectedPacks.forEach(pack => {
			if (!selectedPackAncillaries[pack.segmentId]) {
				selectedPackAncillaries[pack.segmentId] = [] 
				pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(ancillary => {
					if (!selectedPackAncillaries[pack.segmentId].includes(ancillary.type) && ![EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_EQUIPMENT].includes(ancillary.type)) {
						selectedPackAncillaries[pack.segmentId].push(ancillary.type)
					}
				});
			} else {
				pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(ancillary => {
					if (!selectedPackAncillaries[pack.segmentId].includes(ancillary.type) && ![EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_EQUIPMENT].includes(ancillary.type)) {
						selectedPackAncillaries[pack.segmentId].push(ancillary.type);
					}
				});
			}
		})

		bundleList.forEach(bundle => {
			if (bundle.ancillaryList[0].catalog) {
				bundle.ancillaryList[0].catalog.forEach(catalog => {
					if (catalog.flightId === flightId) {
						if (!selectedPackAncillaries[catalog.segmentId] || !selectedPackAncillaries[catalog.segmentId].includes(bundle.ancillaryList[0].type)) {
							// If ancillary not added in pack, push to whitelist
							ancillariesOnOtherSegment.push({
								type: bundle.ancillaryList[0].type,
								element: catalog
							});
							const element = document.getElementById(`${bundle.ancillaryList[0].type}_${flightId}`);
							if (element) {
								element.style.display = '';
							}

						} else if (ancillariesOnOtherSegment.findIndex(anc => anc.type === bundle.ancillaryList[0].type) === -1) {
							// If ancillary added by pack for all segments, hide from view
							const element = document.getElementById(`${bundle.ancillaryList[0].type}_${flightId}`);
							if (element) {
								element.style.display = 'none';
							}
						}
					}
				});
			}
		});
		return ancillariesOnOtherSegment;
	}
}

class FeaturesMap {
	flight: Flight;
	featuresAdded: INDRAAddOnAncillary[];

	propertiesMapping = {
		seats: {
			changed: this.seatsChanged,
			count: this.seatCount,
			cost: this.seatCosts
		},
		bags: {
			changed: this.bagsChanged,
			count: this.bagsCount,
			cost: this.bagsCost,
		},
		fasttrack: {
			changed: this.fastTrackChanged,
			count: this.fastTrackCount,
			cost: this.fastTrackCost,
		},
		lounge: {
			changed: this.loungeChanged,
			count: this.loungeCount,
			cost: this.loungeCost,
		},
		sports: {
			changed: this.sportsChanged,
			count: this.sportsCount,
			cost: this.sportsCost,
		},
		instruments: {
			changed: this.instrumentsChanged,
			count: this.instrumentsCount,
			cost: this.instrumentsCost,
		},
		pets: {
			changed: this.petsChanged,
			count: this.petsCount,
			cost: this.petsCost,
		},
		meals: {
			changed: this.mealsChanged,
			count: this.mealsCount,
			cost: this.mealsCost,
			skip_count: this.skipCount
		},
		musical: {
			changed: this.musicalChanged,
			count: this.musicalCount,
			cost: this.musicalCost,
		},
		prefBoard: {
			changed: this.prefBoardChanged,
			count: this.prefBoardCount,
			cost: this.prefBoardCost,
		},
	};

	constructor(flight: Flight, featuresAdded: INDRAAddOnAncillary[]) {
		this.flight = flight;
		this.featuresAdded = featuresAdded;
	}

	getCost(feature) {
		return this.flight ? this.propertiesMapping[feature.id].cost.apply(this) : 0;
	}

	hasChanged(feature) {
		return this.flight ? this.propertiesMapping[feature.id].changed.apply(this) : false;
	}

	getCount(feature) {
		return this.flight ? this.propertiesMapping[feature.id].count.apply(this) : 0;
	}

	/**
	 * @param featureId string Any key of propertiesMapping
	 * @param prop string Any property on any object in propertiesMapping
	 * @return outcome after executing any method linked with prop
	 */
	executeMethod(featureId: string, prop: string){
		const property = this.propertiesMapping[featureId];
		type ObjectKey = keyof typeof property;
		const keyProp = prop as ObjectKey;
		return this.flight && property ? property[keyProp].apply(this) : null;
	}

	private seatsChanged() {
		return this.seatCount() > 0;
	}

	private seatCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_SEAT ? 1 : 0)), 0);
	}

	private seatCosts() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_SEAT ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private bagsChanged() {
		return this.bagsCount() > 0;
	}

	private bagsCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_BAG ? 1 : 0)), 0);
	}

	private bagsCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_BAG ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private fastTrackChanged() {
		return this.fastTrackCount() > 0;
	}

	private fastTrackCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_FAST_TRACK ? 1 : 0)), 0);
	}

	private fastTrackCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_FAST_TRACK ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private loungeChanged() {
		return this.loungeCount() > 0;
	}

	private loungeCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_LOUNGE ? 1 : 0)), 0);
	}

	private loungeCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_LOUNGE ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private sportsChanged() {
		return this.sportsCount() > 0;
	}

	private sportsCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_EQUIPMENT ? 1 : 0)), 0);
	}

	private sportsCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_EQUIPMENT ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private instrumentsChanged() {
		return this.instrumentsCount() > 0;
	}

	private instrumentsCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? 1 : 0)), 0);
	}

	private instrumentsCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private petsChanged() {
		return this.petsCount() > 0;
	}

	private petsCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_ANIMAL ? 1 : 0)), 0);
	}

	private petsCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_ANIMAL ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private mealsChanged() {
		return this.mealsCount() > 0;
	}

	private mealsCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_MEAL ? 1 : 0)), 0);
	}

	private mealsCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_MEAL ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private skipCount(): number {
		/**
		 * Get the first stop and duplicate infor for other flights
		 */
		return this.featuresAdded.reduce(((sum, item) => sum + (item.code === SSR_CODE_MEAL_SKIP ? 1 : 0)), 0);
	}

	// MUSCIAL
	private musicalChanged() {
		return this.musicalCount() > 0;
	}

	private musicalCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? 1 : 0)), 0);
	}

	private musicalCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_MUSICAL ? parseFloat(item.price.toString()) : 0)), 0);
	}

	private prefBoardChanged() {
		return this.prefBoardCount() > 0;
	}

	private prefBoardCount() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_PREF_BOARD ? 1 : 0)), 0);
	}

	private prefBoardCost() {
		return this.featuresAdded.reduce(((sum, item) => sum + (item.type === EXTRAS_ANCILLARY_PREF_BOARD ? parseFloat(item.price.toString()) : 0)), 0);
	}

	/* from Sprint 8 merge 
	TAP_formatMiles(value) {
		return value.toLocaleString('pt') + ' ' + this.promotype;
	}

	TAP_formatCash(value) {
		value = parseFloat(value);
		return value.toLocaleString('pt', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + this.currency.symbol;
	}
	*/
	
}
